// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginWrapper_root__1gVUi","wrapper":"LoginWrapper_wrapper__38jqg"};